import { PageLayout } from '@gumtree/shared/src/types/srp';
import { Categories, DeviceTypes } from '@gumtree/shared/src/types/client-data';

export const determinePageLayout = ({
    deviceType,
    category,
}: {
    deviceType: DeviceTypes | undefined;
    category: Categories;
}): PageLayout => {
    if (category.l1Category === 'jobs') {
        return PageLayout.OneColumn;
    }

    const isMobileTwoColumn =
        category.l1Category === 'for-sale' ||
        category.l2Category === 'pet-equipment-accessories' ||
        category.l2Category === 'motors-parts' ||
        category.l2Category === 'motors-accessories';

    if (deviceType === DeviceTypes.MOBILE) {
        return isMobileTwoColumn ? PageLayout.TwoColumns : PageLayout.OneColumn;
    } else if (deviceType === DeviceTypes.TABLET || deviceType === DeviceTypes.DESKTOP) {
        return PageLayout.OneColumn;
    }

    return PageLayout.OneColumn;
};

export const determineGaLabel = (viewportWidth: number, pageLayout: PageLayout) => {
    let srpIsGridOrList: string | undefined;
    if (viewportWidth < 768) {
        if (pageLayout === PageLayout.OneColumn) {
            srpIsGridOrList = 'OneColumnCardView';
        } else if (pageLayout === PageLayout.TwoColumns) {
            srpIsGridOrList = 'TwoColumnGridView';
        }
    } else {
        if (pageLayout === PageLayout.OneColumn) {
            srpIsGridOrList = 'ListView';
        } else if (pageLayout === PageLayout.TwoColumns) {
            srpIsGridOrList = 'TwoColumnGridView';
        } else if (pageLayout === PageLayout.ThreeColumns) {
            srpIsGridOrList = 'ThreeColumnGridView';
        }
    }

    return srpIsGridOrList;
};
